import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import DonationsPage from "../../components/donations";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Donations = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Donations" />
    <Layout>
      <Routes>
        <Route path="" element={<DonationsPage />} />
        <Route path=":donorId" element={<DonationsPage />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Donations;
